exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-blog-post-tsx": () => import("./../../../src/templates/blog-post.tsx" /* webpackChunkName: "component---src-templates-blog-post-tsx" */),
  "component---src-templates-pagination-page-tsx": () => import("./../../../src/templates/pagination-page.tsx" /* webpackChunkName: "component---src-templates-pagination-page-tsx" */)
}

